// extracted by mini-css-extract-plugin
module.exports =  {"layout":"RiJ4J","content":"lbC1q"};